import Vue from "vue";
import Login from "../components/Login";
import JobOffers from "../components/JobOffers";
import Applications from "../components/Applications";
import Archive from "../components/Archive";
import NotAllowed from "../components/NotAllowedView";
import SpecialResponse from "../components/SpecialResponse";
import ResponseEditor from "../components/ResponseEditor";
import ScheduledMails from "../components/ScheduledMails.vue";
import ApplicationsWatcherPage from "../components/ApplicationsWatcherPage.vue";

import Router from "vue-router";
import { auth } from "../plugins/firebase";
import store from "../store";
import ApplicationPool from "../components/ApplicationPool.vue";
import EmployedArchive from "../components/EmployedArchive.vue";
import StatsView from "../components/StatsView.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: "/login",
    },
    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/token/:token",
      component: Login,
      name: "Token",
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/notallowed",
      name: "NotAllowed",
      component: NotAllowed,
    },
    {
      path: "/stellenangebote",
      name: "jobOffers",
      component: JobOffers,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/bewerbungen",
      name: "applications-overview",
      component: Applications,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/bewerbungen/:code",
      name: "applications",
      component: Applications,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/specialresponse",
      name: "specialresponse",
      component: SpecialResponse,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/responseeditor",
      name: "responseeditor",
      component: ResponseEditor,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/betrachter",
      name: "betrachter-overview",
      component: ApplicationsWatcherPage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/betrachter/:code",
      name: "betrachter",
      component: ApplicationsWatcherPage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/scheduledmails",
      name: "scheduledmails",
      component: ScheduledMails,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/archiv",
      name: "archive",
      component: Archive,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/pool",
      name: "pool",
      component: ApplicationPool,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/talents-pool",
      name: "talents-pool",
      component: ApplicationPool,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/employed-archive",
      name: "employed-archive",
      component: EmployedArchive,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/stats",
      name: "statistics",
      component: StatsView,
      meta: {
        requiresAuth: true,
      },
    }
  ],
});

router.beforeEach(async (to, from, next) => {
  const currentUser = store.state.user;
  const getIdTokenResult = currentUser
    ? await auth.currentUser?.getIdTokenResult()
    : null;

  const isUser = getIdTokenResult?.claims?.user === "true" || false;
  const isAdmin = getIdTokenResult?.claims?.admin === "true" || false;
  const isWatcher = getIdTokenResult?.claims?.betrachter === "true" || false;
  const isWatcherWithoutAnswerFunction = getIdTokenResult?.claims?.betrachter_ohne_antwort_funktion === "true" || false;

  const isWatcherOrWatcherWithoutAnswerFunction = isWatcher || isWatcherWithoutAnswerFunction;

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  // Umleiten nicht authentifizierter Benutzer bei geschützten Seiten
  if (requiresAuth && !currentUser) {
    return next({ name: "login" });
  }

  // Nur Admin darf alles
  if (isUser && isAdmin) {
    return next();
  }

  // Nur User dürfen JobOffers sehen
  if (to.name === "jobOffers" && isUser && !isWatcher && !isWatcherWithoutAnswerFunction) {
    return next();
  }

  // Nur Watcher oder Watcher ohne Antwortfunktion dürfen ApplicationsWatcherPage sehen
  if ((to.name === "betrachter" || to.name === "betrachter-overview") && isUser && isWatcherOrWatcherWithoutAnswerFunction) {
    return next();
  }

  // Watcher und Watcher ohne Antwortfunktion werden auf ApplicationsWatcherPage umgeleitet
  if (to.name === "applications-overview" && isUser && isWatcherOrWatcherWithoutAnswerFunction) {
    return next({name: 'betrachter-overview'});
  }

  // Watcher und Watcher ohne Antwortfunktion dürfen ihnen freigegebene Applications sehen
  if (to.name === "applications" && isUser && isWatcherOrWatcherWithoutAnswerFunction){
      return next({name: 'betrachter'});
  }

  if (to.name === "login" && currentUser && isUser && !isWatcher && !isWatcherWithoutAnswerFunction) {
    return next({ name: "jobOffers" });
  } else if (to.name === "login" && currentUser && isUser) {
    return next({ name: "betrachter-overview" });
  } else if (to.name === "login" && currentUser && isWatcherOrWatcherWithoutAnswerFunction) {
    return next({ name: "betrachter-overview" });
   } else if (to.name === "login" && currentUser && isAdmin) {
    return next({ name: "applications-overview" });
  }

  if (!requiresAuth){
    return next()
  }

  return next({name: "NotAllowed"})
});

export default router;
